<template>
    <div>
        <el-form label-width="110px" label-position="left" :inline="true" :model="data" class="query-form" size="small">
            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">询价信息
                <el-button  size="small"  style="width: 80px;position: absolute;right: 20px;" @click.native="goback">返回</el-button>
            </h1>
            <el-form-item class="query-form-item" label="ID:">
                {{ data.id }}
            </el-form-item>

            <el-form-item class="query-form-item" label="姓名:">
                {{ data.name }}
            </el-form-item>
            <el-form-item class="query-form-item" label="邮件地址:">
                {{ data.mail }}
            </el-form-item>
            <el-form-item class="query-form-item" label="公司名称:">
                {{ data.company }}
            </el-form-item>
            <el-form-item class="query-form-item" label="国家:">
                {{ data.country }}
            </el-form-item>
            <el-form-item class="query-form-item" label="邮编:">
                {{ data.zipCode }}
            </el-form-item>
            <el-form-item class="query-form-item" label="联系电话:">
                {{ data.phone }}
            </el-form-item>
            <el-form-item class="query-form-item" label="详细地址:">
                {{ data.detailAddress }}
            </el-form-item>
            <el-form-item class="query-form-item" label="详情:">
                {{ data.informaition }}
            </el-form-item>
            <el-form-item class="query-form-item" label="附件:">
                <template v-for="item in data.urls">
                    <span :key="item.id">
                        <a :href="item.url" target="_blank" >{{ item.name }} &nbsp;&nbsp;&nbsp;</a>
                    </span>
                </template>
            </el-form-item>
            <el-form-item class="query-form-item" label="提交时间:">
                {{  data.createTime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}
            </el-form-item>
            <el-form-item class="query-form-item" label="处理时间:">
                <span v-if="data.handleTime!=null">{{data.handleTime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}</span>
                <span v-if="data.handleTime==null">--</span>
            </el-form-item>
            <el-form-item class="query-form-item" label="处理人:">
                {{ data.authadminName }}
            </el-form-item>
            <el-form-item class="query-form-item" label="处理状态:">
                {{ data.state==2?'未处理':'已处理' }}
                <el-button v-if="data.state==2" style="margin-left: 20px;" type="text"  @click="editFreight(data.id)">处理</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {getDetailsApi, handleApi} from "@/api/generalinquiry/generalinquiry";
import {getAdminId} from "@/utils/auth";
export default {
    data() {
        return {
            loading: false,
            data: {},
            list: [{
                commodityNum:"",
                commodityUrl:"",
                commodityName:"",
                speclWeight:"",
                specStand:""
            }],
            query:{
                id:0
            },
            freightVisible: false,
            price:""
        };
    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        getAskerDetailsFn() {
            getDetailsApi(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.data = response.data || {};

                    this.list[0].commodityNum=this.data.commodityNum;
                    this.list[0].commodityUrl=this.data.commodityUrl;
                    this.list[0].commodityName=this.data.commodityName;
                    this.list[0].speclWeight=this.data.speclWeight;
                    this.list[0].specStand=this.data.specStand;
                })
                .catch(() => {});
        },
        editFreight(id) {
            this.freightVisible = true;
            let adminId= getAdminId();
            if (id) {
                this.$confirm("确认要处理吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = {
                            id: id,
                            adminId: adminId
                        };
                        handleApi(para)
                            .then(response => {
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("处理成功！");
                                this.getAskerDetailsFn();
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            }

        },
        // 下载
        downloadXML(url) {
            console.log("==============================",url)
            // 如果有值，直接下载
            let that = this;
            that.loading = true;
            window.location.href = url;
            that.loading = false;
        },
    },
    filters: {},
    mounted() {},
    created() {
        this.query.id = this.$route.query.id;
        this.getAskerDetailsFn();
    }
};

</script>
<style scoped>
/deep/ .query-form {
    color: #606266;
    width: 1200px !important;
    border: 1px solid #f4f4f5;
    border-bottom: none;
    margin-bottom: 40px;
    /* border-left: none; */
}

/deep/ .query-form-item {
    /* display: block !important; */
    width: 50% !important;
    margin-right: 0 !important;
    padding: 10px 0;
    margin-bottom: 0 !important;
    border-bottom: 1px solid #f4f4f5;
    /* border-left: 1px solid #F4F4F5; */
}

/deep/ .query-form-item-big {
    width: 100% !important;
}

/deep/ .el-form-item__label {
    padding-left: 20px;
}

/deep/ .query-form-item-big .el-form-item__content {
    padding: 0 20px;
    text-indent: 4em;
}

.inquiryDetailsTitle {
    line-height: 50px;
    background: #f4f4f5;
    padding-left: 20px;
}

/deep/ .el-table--border {
    width: 1200px;
}

/deep/ .el-table__body td {
    padding: 12px 0 !important;
}

/deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
}
</style>
